import { Alert, AlertDescription, AlertIcon, Button, CloseButton, Flex, Input, InputGroup, Spacer, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { REGISTER_FORM_VALIDATIONS } from '../yup-validatons';
import Link from 'next/link';
import PhoneInput from '../../../components/PhoneInput';
import { SIGN_UP_USER } from '../../../api/mutations/auth';
import { save_token } from '../../../utils/CookieStore';
import { useBranchIo } from '../../../contexts/branch-io-provider';
import { useCountries } from '../../../contexts/country-provider';
import { useMutation } from '@apollo/client';
import { useRouter } from 'next/router';
import { IRegister } from '../types';
const RegisterForm = () => {
  const router = useRouter();
  const {
    data: branchData
  } = useBranchIo();
  const {
    selectedCountry
  } = useCountries();
  const {
    register,
    handleSubmit,
    setValue,
    formState: {
      errors
    },
    watch
  } = useForm<IRegister>({
    resolver: yupResolver(REGISTER_FORM_VALIDATIONS),
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      referrer: branchData?.data_parsed?.referrer_code
    }
  });
  const [signup, {
    loading: registeringUser,
    error: userRegistrationError
  }] = useMutation(SIGN_UP_USER, {
    onError: () => {
      setShowErrorAlert(true);
    },
    onCompleted: returnVal => {
      const {
        signupUser: {
          pinId,
          token
        }
      } = returnVal;
      save_token(token);
      router.push(`/otp/${pinId}?to=${watch('phone').substring(1)}`);
    }
  });
  const onSubmit = async (data: IRegister) => {
    signup({
      variables: {
        ...data,
        phone: `${data.phone.substring(1)}`,
        partnerCode: process.env.NEXT_PUBLIC_PARTNER_CODE,
        countryCode: selectedCountry?.iso_code_3
      }
    });
  };
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [isSubmitBtnDisabled, setDisableSubmitBtn] = useState(true);
  return <Flex flexDirection="column" gap={4} as="form" onSubmit={handleSubmit(onSubmit)} data-sentry-element="Flex" data-sentry-component="RegisterForm" data-sentry-source-file="RegisterForm.tsx">
      <InputGroup zIndex={1} display="flex" flexDirection="column" gap={4} data-sentry-element="InputGroup" data-sentry-source-file="RegisterForm.tsx">
        <PhoneInput value={watch('phone')} onChange={phone => {
        setValue('phone', phone, {
          shouldValidate: true
        });
      }} disableBtn={setDisableSubmitBtn} data-sentry-element="PhoneInput" data-sentry-source-file="RegisterForm.tsx" />
        {errors.phone && <Text color="red.500" fontSize="sm">
            {errors.phone.message}
          </Text>}

        <Input placeholder="First Name" p={6} isInvalid={!!errors.firstName} {...register('firstName')} data-sentry-element="Input" data-sentry-source-file="RegisterForm.tsx" />
        {errors.firstName && <Text color="red.500" fontSize="sm">
            {errors.firstName.message}
          </Text>}

        <Input placeholder="Last Name" p={6} isInvalid={!!errors.lastName} {...register('lastName')} data-sentry-element="Input" data-sentry-source-file="RegisterForm.tsx" />
        {errors.lastName && <Text color="red.500" fontSize="sm">
            {errors.lastName.message}
          </Text>}

        <Input placeholder="Email Address" p={6} type="email" isInvalid={!!errors.email} {...register('email')} data-sentry-element="Input" data-sentry-source-file="RegisterForm.tsx" />
        {errors.email && <Text color="red.500" fontSize="sm">
            {errors.email.message}
          </Text>}

        {/* {isMTN && (
          <Input
            placeholder="Referral Code"
            name="referrer"
            p={6}
            onChange={(event) => handleInputChange(event)}
            value={user.referrer}
            type="text"
            required
          />
         )} */}
      </InputGroup>

      {showErrorAlert && <Alert status="error" style={{
      marginTop: '1rem'
    }}>
          <AlertIcon />
          <AlertDescription>{userRegistrationError?.message}</AlertDescription>
          <Spacer />
          <CloseButton alignSelf="flex-start" position="relative" right="-1" top={-1} onClick={() => setShowErrorAlert(false)} />
        </Alert>}

      <Button type="submit" bg="#0F61D6" color="#fff" _hover={{
      bg: '#0F61D6',
      opacity: '0.9'
    }} p={6} w="100%" isDisabled={isSubmitBtnDisabled} isLoading={registeringUser} loadingText="Registering User" data-sentry-element="Button" data-sentry-source-file="RegisterForm.tsx">
        Next
      </Button>
      <Text textAlign="center" data-sentry-element="Text" data-sentry-source-file="RegisterForm.tsx">
        {`Already have an account?`}{' '}
        <span style={{
        color: 'blue',
        textDecoration: 'underline',
        cursor: 'pointer'
      }}>
          <Link href="/login" data-sentry-element="Link" data-sentry-source-file="RegisterForm.tsx">Login</Link>
        </span>
      </Text>
      {/* </Link> */}
    </Flex>;
};
export default RegisterForm;